import { Spin } from 'antd'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'state'
import { setModalNotification } from 'state/modal/actions'
import styled from 'styled-components'
import Modal from '../../widgets/Poms/Modal'

const CredentialsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  textarea {
    background-color: #fff2d1;
    border: none;
    border-radius: 0.5rem;
    width: 100%;
    padding: 0.5rem 0.8rem;
    outline: none;

    ::placeholder {
      color: #d48941;
    }

    &.blur {
      filter: blur(3px);
    }
  }

  .description {
    padding: 0 0.5rem;
    color: #c15a00;
    font-family: Jua;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
  }

  .dog-btns {
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 1rem;
  }
`

const DogButton = styled.button`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin: 1rem 0 0;
  box-shadow: none;
  width: 100px;

  font-size: 1.2rem;
  color: #fff;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #d18d00;
  font-family: Jua;
  font-style: normal;
  font-weight: 400;
  line-height: 0;
  white-space: nowrap;

  position: relative;

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    gap: 5px;

    span {
      margin-top: 2px;
    }
  }
`

const ModalNotification: FC = () => {
  const dispatch = useDispatch()
  const { toggle, dataModal } = useSelector((state: AppState) => state.modal.modalNotification)

  const handleClose = () => {
    if (dataModal?.buttonDisabled) return
    dispatch(setModalNotification({ toggle: false, dataModal: null }))
  }

  return (
    <Modal show={toggle} onClose={handleClose}>
      <div className={'modal-header'}>Notification</div>
      <CredentialsWrapper>
        <div className='description'>
          {dataModal?.message} {dataModal?.loading && <Spin />}
        </div>

        <div className={'dog-btns'}>
          <DogButton onClick={handleClose} disabled={dataModal?.buttonDisabled}>
            <img src='/images/home/gold-btn.png' alt='View' />
            <div>
              <span>Close</span>
            </div>
          </DogButton>
        </div>
      </CredentialsWrapper>
    </Modal>
  )
}

export default ModalNotification
